// Version : 1.0.0
// Author : AGALYA
import { takeLatest, put, all, call } from 'redux-saga/effects';
import BasicDetailsActionType from './basic-details.types';
import {
	basicDetailsAddSuccess,
	basicDetailsAddFailure,
	basicDetailsAddUserResponseChanged,
} from './basic-details.action';
import { encryptData } from '../../../_common/enode-decode';
import AlertManager from '../../../../utils/alertManager';
import { basicMemberDetailsAdd } from './basic-details.service';

/** ***************** BASIC DETAILS ADD START *********************** */
export function* AddBasicDetails({ payload }: any) {
	try {
		const key = 'AddMemberBasicDetails';
		const {
			companyID,
			databaseName,
			memberID,
			memberName,
			memberDateOfBirth,
			memberGender,
			memberAadharNumber,
			aadharQRjson,
			memberPanNumber,
			pincode,
			doorNo,
			addressStreet,
			city,
			district,
			state,
			currentPincode,
			currentDoorNo,
			currentAddressStreet,
			currentState,
			currentDistrict,
			currentCity,
			country,
			memberPhone,
			userID,
			isAadharScanned,
			isAadharVerified,
		} = payload;

		const jsonData = {
			CompanyID: companyID,
			DatabaseName: databaseName,
			MemberID: memberID,
			MemberName: memberName,
			MemberDateOfBirth: memberDateOfBirth,
			MemberGender: memberGender,
			MemberAadharNumber: memberAadharNumber,
			AadharJSON: aadharQRjson,
			MemberPanNumber: memberPanNumber,
			IsAadharVerified: isAadharVerified,
			Pincode: pincode,
			DoorNo: doorNo,
			AddressStreet: addressStreet,
			City: city,
			District: district,
			State: state,
			CurrentPincode: currentPincode,
			CurrentDoorNo: currentDoorNo,
			CurrentAddressStreet: currentAddressStreet,
			CurrentState: currentState,
			CurrentDistrict: currentDistrict,
			CurrentCity: currentCity,
			Country: country,
			MemberPhone: memberPhone,
			OfficerID: userID,
			IsAadharScanned: isAadharScanned,
			Secratekey: key,
		};
		const verifyData = encryptData(jsonData, key);
		// @ts-ignore
		const responseData = yield call(basicMemberDetailsAdd, verifyData);
		// Check for 401 token validation error
		if (responseData.data.statusCode === '401') {
			// Show token validation alert
			AlertManager.showTokenValidationAlert();
			return;
		} else if (responseData.data.statusCode === '100') {
			yield put(basicDetailsAddFailure(responseData.data));
		} else {
			yield put(basicDetailsAddSuccess(responseData.data));
		}
	} catch (error) {
		yield put(basicDetailsAddFailure(error));
	}
}

export function* AddBasicDetailsResponseClear() {
	yield put(basicDetailsAddUserResponseChanged());
}

export function* onBasicDetailsAddStart() {
	yield takeLatest(BasicDetailsActionType.BASIC_DETAILS_ADD_START, AddBasicDetails);
}

export function* onBasicDetailsAddResponseRest() {
	yield takeLatest(
		BasicDetailsActionType.BASIC_DETAILS_ADD_RESPONSE_REST_START,
		AddBasicDetailsResponseClear,
	);
}
/** ***************** BASIC DETAILS ADD END *********************** */

export function* basicDetailsSaga() {
	yield all([call(onBasicDetailsAddStart), call(onBasicDetailsAddResponseRest)]);
}
